import React, { useState, useEffect, useMemo, lazy, Suspense } from "react";
import classes from "./home.module.scss";
import CarouselHeroSection from "./CarouselHeroSection/CarouselHeroSection";
import axios from "../../requests/axios";
import routes from "../../requests/routes";

import home from "../../assets/imgs/home_11zon.webp";
import home2 from "../../assets/imgs/home2_11zon.webp";
import home3 from "../../assets/imgs/home3_11zon.webp";
import ProgramList from "../../generic components/Program List/ProgramList";
import { ArrowRightAlt } from "@mui/icons-material";
import { Link } from "react-router-dom";
const CounterSection = lazy(() => import("./counter/CounterSection"));
const Values = lazy(() => import("./newValues/Values"));
const Anchor = lazy(() => import("./anchor/anchor"));
const Subscribe = lazy(() => import("./subscribe/Subscribe"));
const Partners = lazy(() => import("./partners/Partners"));
const ReviewsList = lazy(() =>
  import("../../generic components/Reviews List/ReviewsList")
);
const SpecialRequest = lazy(() => import("./specialRequest/SpecialRequest"));
const WhatsappIcon = lazy(() => import("./whatsappIcon/whatsappIcon"));
const EventsBody = lazy(() => import("../Events/EventsBody/EventsBody"));

const PLACEHOLDER_ITEMS = Object.freeze([0, 0, 0]);

const formatHomeData = (payload = {}) => ({
  programs: Array.isArray(payload.programs) ? payload.programs : [],
  counts: payload.counts ?? null,
  reviews: Array.isArray(payload.reviews) ? payload.reviews : [],
});

const HomePage = () => {
  const [homeData, setHomeData] = useState(() => formatHomeData());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getHome = async () => {
      setLoading(true);
      try {
        const response = await axios.get(routes.getHome, {
          signal: controller.signal,
        });
        if (!isMounted) {
          return;
        }
        setHomeData(formatHomeData(response.data));
      } catch (err) {
        if (err?.code !== "ERR_CANCELED") {
          console.error("Failed to fetch home data", err);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    getHome();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  const heroImages = useMemo(() => [home2, home3, home], []);
  const programsPreview = useMemo(() => {
    if (homeData.programs.length > 0) {
      return homeData.programs.slice(0, 3);
    }
    return loading ? PLACEHOLDER_ITEMS : [];
  }, [homeData.programs, loading]);

  const reviewsPreview = useMemo(() => {
    if (homeData.reviews.length > 0) {
      return homeData.reviews.slice(0, 3);
    }
    return loading ? PLACEHOLDER_ITEMS : [];
  }, [homeData.reviews, loading]);

  return (
    <>
      <div className={classes.container}>
        <CarouselHeroSection
          title="FLY TO CONNECT"
          btn="Book Now"
          images={heroImages}
          tintColor="var(--green)"
        />

        <ProgramList
          title={true}
          events={programsPreview}
          load={loading}
        />
        <Suspense fallback={null}>
          <CounterSection counts={homeData.counts} load={loading} />
        </Suspense>
        <Suspense fallback={null}>
          <Values />
        </Suspense>
        <Suspense fallback={null}>
          <ReviewsList title={true} reviews={reviewsPreview} load={loading} />
        </Suspense>
        <div className={classes.events_section}>
          <Suspense fallback={null}>
            <EventsBody />
          </Suspense>
          <Link to="/events" className={"see_more"} scroll="yes">
            Explore Events <ArrowRightAlt />
          </Link>
        </div>

        <Suspense fallback={null}>
          <Partners />
        </Suspense>

        <div className={classes.subscribeSection}>
          <Suspense fallback={null}>
            <Subscribe />
          </Suspense>
        </div>
        <Suspense fallback={null}>
          <Anchor />
        </Suspense>
        <Suspense fallback={null}>
          <WhatsappIcon />
        </Suspense>
        <Suspense fallback={null}>
          <SpecialRequest />
        </Suspense>
      </div>
    </>
  );
};

export default HomePage;
